const attraction = {
  campaignSidebar: false,
  campaignContacts: false,
  campaignAutomation: false,
  campaignDispatches: false,
  campaignBuilder: false,
  platformBroadcast: false,
  notifications: false,
}

export default {
  authentication: false,
  channelMessenger: false,
  channelSms: false,
  channelVoice: false,
  channelWhatsApp: false,
  channelWebchat: false,
  channelRcs: false,
  components: false,
  webComponents: false,
  customerPanel: false,
  eventbus: false,
  featureToggle: false,
  home: false,
  logsApi: false,
  selfservice: false,
  flows: false,
  organizations: false,
  channelInstagram: false,
  platformReport: false,
  labs: false,
  platformErrorsPage: false,
  homeV2: false,
  navbarV2: false,
  feedbackService: false,
  channelV2: false,
  customerDataService: false,
  ...attraction,
}
